import React from "react";

import {
  MyProfile as Profile
} from "components/MyProfile";

export const MyProfile = () => {
  return (
    <Profile
      disabledEdit={false}
    />
  );
};
